module.exports = __webpack_public_path__ + "media/images/athletes/4171-d24308dd734c2a9898526d4cee919ba2.png";